import { SearchBoxPlaceholder } from '@cinch-nx/data-search'

/**
 * Default fallback count when total inventory count is not available
 */
export const DEFAULT_VEHICLE_COUNT = 10_000

/**
 * Generate default search placeholders with dynamic vehicle count
 * @param totalCount - Total inventory count (optional, defaults to DEFAULT_VEHICLE_COUNT)
 */
export const getDefaultSearchPlaceholders = (
  totalCount?: number,
): SearchBoxPlaceholder[] => {
  const count = totalCount ?? DEFAULT_VEHICLE_COUNT
  const formattedCount = count.toLocaleString('en-GB')

  return [
    {
      _uid: '1',
      component: 'Text',
      text: `Search ${formattedCount} used cars`,
    },
    {
      _uid: '2',
      component: 'Text',
      text: 'An EV for long distances',
    },
    {
      _uid: '3',
      component: 'Text',
      text: 'What can I get for £350?',
    },
    {
      _uid: '4',
      component: 'Text',
      text: 'I need heated seats',
    },
    {
      _uid: '5',
      component: 'Text',
      text: 'Must have Android Auto',
    },
  ]
}

/**
 * Static default placeholders for backward compatibility
 * @deprecated Use getDefaultSearchPlaceholders() instead for dynamic count
 */
export const DEFAULT_SEARCH_PLACEHOLDERS: SearchBoxPlaceholder[] =
  getDefaultSearchPlaceholders()
